import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import right from "../../assets/images/right.svg";
import left from "../../assets/images/left.svg";

import "swiper/css";
import "swiper/css/pagination";
import offer from "../../assets/images/launching.png";
type Service = {
  title: string;
  text: string;
};

const services: Service[] = [
  {
    title: "Therapy That Cares",
    text: "Whether you’re managing stress, anxiety, or life’s challenges, our licensed professionals are here to provide a safe, judgment-free space to heal and grow.",
  },
  {
    title: "Counseling That Empowers",
    text: "Tailored guidance to help you navigate relationships, career hurdles, and personal milestones with clarity and confidence.",
  },
];

const Launching = () => {
  return (
    <div className="relative w-full">
      <img src={offer} className="w-full object-cover h-[calc(80vh)]" alt="" />

      <div className="absolute flex flex-wrap jost-regular px-4 sm:px-12 justify-center text-white items-center top-[5%] sm:top-[15%] w-full">
        <div className="flex flex-col gap-3 justify-center">
          <h1 className="text-3xl sm:text-5xl">
            Launching
            <span className="text-3xl sm:text-5xl italic ml-2 font-eiko-thin">
              soon
            </span>
          </h1>
        </div>
      </div>

      <div className="absolute max-h-[600px] overflow-hidden flex flex-wrap jost-regular px-4 sm:px-12 justify-center text-white items-center top-[20%] sm:top-[35%] w-full">
        <div className="hidden overflow-hidden sm:grid lg:grid-cols-2 max-w-[700px] gap-5">
          {services.map((item) => (
            <div
              key={item.title}
              className="border bg-white bg-opacity-20 group hover:bg-opacity-100 transition-all duration-300 border-white rounded-2xl group cursor-pointer py-6"
            >
              <div className="pt-8 px-10 h-full rounded-2xl transition-all duration-300">
                {" "}
                <h3 className="!font-semibold text-3xl mb-4 group-hover:text-secondary">
                  {item.title}
                </h3>
                <p className="montserrat-regular group-hover:text-black mb-4">
                  {item.text}
                </p>
                {/* <div className="flex items-center gap-4 mt-8 mb-4 montserrat-semibold group-hover:text-secondary text-white cursor-pointer"> */}
                {/*   MORE INFO */}
                {/*   <svg */}
                {/*     xmlns="http://www.w3.org/2000/svg" */}
                {/*     width="30" */}
                {/*     height="8" */}
                {/*     viewBox="0 0 30 8" */}
                {/*     fill="none" */}
                {/*     className="group-hover:translate-x-2 transition-all duration-300" */}
                {/*   > */}
                {/*     <path */}
                {/*       className="group-hover:fill-secondary" */}
                {/*       d="M29.3536 4.35355C29.5488 4.15829 29.5488 3.84171 29.3536 3.64645L26.1716 0.464466C25.9763 0.269204 25.6597 0.269204 25.4645 0.464466C25.2692 0.659728 25.2692 0.976311 25.4645 1.17157L28.2929 4L25.4645 6.82843C25.2692 7.02369 25.2692 7.34027 25.4645 7.53553C25.6597 7.7308 25.9763 7.7308 26.1716 7.53553L29.3536 4.35355ZM0 4.5H29V3.5H0V4.5Z" */}
                {/*       fill="white" */}
                {/*     /> */}
                {/*   </svg> */}
                {/* </div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="sm:hidden w-full">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center "
            spaceBetween={10}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            navigation={{
              nextEl: ".next-btn",
              prevEl: ".prev-btn",
            }}
            loop
          >
            {services.map((item) => (
              <SwiperSlide
                key={item.title}
                className="border bg-white bg-opacity-20 group hover:bg-opacity-100 transition-all duration-300 border-white rounded-2xl group cursor-pointer py-6"
              >
                <div className="pt-8 px-10 h-full rounded-2xl transition-all duration-300">
                  {" "}
                  <h3 className="!font-semibold text-3xl mb-4 group-hover:text-secondary">
                    {item.title}
                  </h3>
                  <p className="montserrat-regular group-hover:text-black">
                    {item.text}
                  </p>
                  <div className="flex items-center gap-4 mt-8 mb-4 montserrat-semibold group-hover:text-secondary text-white cursor-pointer">
                    MORE INFO
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="8"
                      viewBox="0 0 30 8"
                      fill="none"
                      className="group-hover:translate-x-2 transition-all duration-300"
                    >
                      <path
                        className="group-hover:fill-secondary"
                        d="M29.3536 4.35355C29.5488 4.15829 29.5488 3.84171 29.3536 3.64645L26.1716 0.464466C25.9763 0.269204 25.6597 0.269204 25.4645 0.464466C25.2692 0.659728 25.2692 0.976311 25.4645 1.17157L28.2929 4L25.4645 6.82843C25.2692 7.02369 25.2692 7.34027 25.4645 7.53553C25.6597 7.7308 25.9763 7.7308 26.1716 7.53553L29.3536 4.35355ZM0 4.5H29V3.5H0V4.5Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="gap-6 flex justify-center items-center py-4">
            <button className="px-2 py-3 flex prev-btn justify-center hover:bg-primary hover:border-none border border-white group btn-disabled disabled:bg-white disabled:border w-12 h-12 items-center rounded-full disabled:border-black">
              <img src={left} alt="" className="text-white" />
            </button>
            <button className="px-2 py-3 group flex next-btn justify-center border hover:border-none border-white  hover:bg-primary btn-disabled disabled:bg-white disabled:border w-12 h-12 items-center rounded-full disabled:border-black">
              <img src={right} alt="" className="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Launching;
